export default __webpack_public_path__ + "static/media/union-red.e9503f60.svg";